import Panel from './panel';
import { getLogger } from '../../logging/logger';

const logger = getLogger('PerformanceStats');
export default class PerformanceStats {
	constructor(fpsConfig, msConfig, memConfig) {
		this.mode = 0;

		this.container = document.createElement('div');
		this.container.classList.add('performance-stats');

		this.container.addEventListener(
			'click',
			(event) => {
				event.preventDefault();
				this.showPanel((this.mode + 1) % this.container.children.length);
			},
			false,
		);

		this.beginTime = (performance || Date).now();
		this.prevTime = this.beginTime;
		this.frames = 0;

		this.fpsPanel = this.addPanel(new Panel('fps', fpsConfig || { fg: '#0ff', bg: '#002' }));
		this.msPanel = this.addPanel(new Panel('ms', msConfig || { fg: '#0f0', bg: '#020' }));
		if (performance && performance.memory)
			this.memPanel = this.addPanel(new Panel('mb', memConfig || { fg: '#f08', bg: '#201' }));

		this.showPanel(0);

		this.dom = this.container;

		// Backwards Compatibility
		this.domElement = this.container;
		this.setMode = this.showPanel;
	}

	addPanel(panel) {
		logger.log('[addPanel]', { panel });
		this.container.appendChild(panel.dom);
		return panel;
	}

	showPanel(id) {
		logger.log('[showPanel]', { id });

		for (let i = 0; i < this.container.children.length; i += 1) {
			if (id === i) {
				this.container.children[i].classList.add('show');
			} else {
				this.container.children[i].classList.remove('show');
			}
		}
		this.mode = id;
	}

	begin() {
		logger.log('[begin]');
		this.beginTime = (performance || Date).now();
	}

	end() {
		logger.log('[end]');
		this.frames += 1;

		const time = (performance || Date).now();

		this.msPanel.update(time - this.beginTime, 200);

		if (time >= this.prevTime + 1000) {
			this.fpsPanel.update((this.frames * 1000) / (time - this.prevTime), 100);

			this.prevTime = time;
			this.frames = 0;

			if (this.memPanel) {
				const { memory } = performance;
				this.memPanel.update(
					memory.usedJSHeapSize / 1048576,
					memory.jsHeapSizeLimit / 1048576,
				);
			}
		}
		return time;
	}

	update() {
		logger.debug('[update]');
		this.beginTime = this.end();
	}
}
